module.exports = __webpack_public_path__ + "img/area-part3-111.56d017de.png";